<template>
  <div class="mbr-root" :style="themePageStyle">
  <head>
    <meta charset="utf-8" /><title>FLOCKR | My Buy Requests</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>
  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <nav class="mbr-topbar">
      <div class="container d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap:16px;">
          <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
          <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">My Buy Requests</span>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-sm btn-outline-secondary" @click="$router.push('/marketplace/buy-requests')"><i class="mdi mdi-format-list-bulleted me-1"></i>Board</button>
          <button class="btn btn-sm btn-warning" @click="$router.push('/marketplace/buy-requests/create')"><i class="mdi mdi-plus me-1"></i>New</button>
        </div>
      </div>
    </nav>

    <div class="container mbr-container">
      <!-- Tabs -->
      <div class="mbr-tabs mb-3">
        <button class="mbr-tab" :class="{active:activeTab==='all'}" @click="activeTab='all'">All ({{ requests.length }})</button>
        <button class="mbr-tab" :class="{active:activeTab==='active'}" @click="activeTab='active'">Active ({{ countStatus('active') }})</button>
        <button class="mbr-tab" :class="{active:activeTab==='fulfilled'}" @click="activeTab='fulfilled'">Fulfilled ({{ countStatus('fulfilled') }})</button>
        <button class="mbr-tab" :class="{active:activeTab==='expired'}" @click="activeTab='expired'">Expired ({{ countStatus('expired') }})</button>
      </div>

      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

      <div v-else-if="filtered.length === 0" class="text-center py-5">
        <i class="mdi mdi-bullhorn-variant-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
        <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">{{ requests.length === 0 ? 'No Buy Requests' : 'No Matching Requests' }}</h5>
        <p style="color:var(--fm-s,#6B6356);">{{ requests.length === 0 ? 'Post your first buy request to find sellers.' : 'Try a different filter.' }}</p>
        <button v-if="requests.length === 0" class="btn btn-warning mt-2" @click="$router.push('/marketplace/buy-requests/create')"><i class="mdi mdi-plus me-1"></i>Post Buy Request</button>
      </div>

      <div v-else>
        <div v-for="(br,bi) in filtered" :key="'br-'+bi" class="mbr-card">
          <div class="d-flex align-items-start gap-3">
            <div class="flex-fill">
              <div class="d-flex align-items-center gap-2 mb-1">
                <h6 class="fw-bold mb-0" style="color:var(--fm-h,#F5F0E8);font-size:14px;cursor:pointer;" @click="$router.push('/marketplace/buy-requests/'+br.id)">{{ br.title }}</h6>
                <span class="mbr-badge" :class="'st-'+br.status">{{ br.status }}</span>
              </div>
              <div class="d-flex flex-wrap gap-1 mb-1">
                <span class="mbr-tag">{{ br.species_name }}</span>
                <span class="mbr-tag">{{ br.quantity_needed }} needed</span>
              </div>
              <div v-if="br.budget_min || br.budget_max" style="color:#BFA164;font-weight:600;font-size:13px;">KES {{ formatPrice(br.budget_min) }} – {{ formatPrice(br.budget_max) }}</div>
              <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:4px;">
                Posted {{ formatDate(br.created_at) }}
                <span v-if="br.expires_at"> · Expires {{ formatDate(br.expires_at) }}</span>
              </div>
            </div>
            <div class="text-end">
              <div class="mbr-resp-count" @click="$router.push('/marketplace/buy-requests/'+br.id)">
                <div style="font-size:18px;font-weight:700;color:#BFA164;">{{ br.response_count || 0 }}</div>
                <div style="font-size:10px;color:var(--fm-s,#6B6356);">responses</div>
              </div>
            </div>
          </div>
          <div class="d-flex gap-2 mt-2 pt-2" style="border-top:1px solid #1A1A1A;">
            <button class="btn btn-sm btn-outline-warning flex-fill" @click="$router.push('/marketplace/buy-requests/'+br.id)"><i class="mdi mdi-eye me-1"></i>View Responses</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </body>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style scoped>
.mbr-root{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh}
.mbr-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:rgba(10,10,10,.95)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.mbr-container{padding-top:80px;padding-bottom:60px;max-width:800px}
.mbr-tabs{display:flex;gap:6px;overflow-x:auto;scrollbar-width:none}
.mbr-tabs::-webkit-scrollbar{display:none}
.mbr-tab{padding:8px 16px;border-radius:20px;border:1px solid var(--fm-br,#2A2520);background:var(--fm-bg1,#141414)!important;color:var(--fm-m,#A09888)!important;font-size:13px;cursor:pointer;transition:all .2s;white-space:nowrap}
.mbr-tab:hover{border-color:#BFA164;color:var(--fm-h,#F5F0E8)!important}
.mbr-tab.active{background:rgba(191,161,100,.15)!important;border-color:#BFA164;color:#BFA164!important;font-weight:600}
.mbr-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;margin-bottom:12px}
.mbr-badge{padding:2px 8px;border-radius:10px;font-size:10px;font-weight:600;text-transform:capitalize}
.st-active{background:rgba(80,200,120,.12)!important;color:#50C878!important}
.st-fulfilled{background:rgba(108,180,238,.12)!important;color:#6CB4EE!important}
.st-expired{background:rgba(107,99,86,.2)!important;color:var(--fm-m,#A09888)!important}
.st-closed{background:rgba(255,107,107,.12)!important;color:#FF6B6B!important}
.mbr-tag{padding:2px 8px;border-radius:10px;font-size:10px;background:rgba(191,161,100,.08)!important;color:#BFA164!important;border:1px solid var(--fm-br,#2A2520)}
.mbr-resp-count{background:var(--fm-bg2,#0F0F0F)!important;border-radius:8px;padding:8px 14px;text-align:center;cursor:pointer;border:1px solid var(--fm-br,#2A2520);transition:all .2s}
.mbr-resp-count:hover{border-color:#BFA164}
</style>
<script>
import { executeJson, flocker } from "@/api";
export default {
  name: "MyBuyRequests",
  data(){return{
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
loading:true,requests:[],activeTab:'all'}},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    filtered(){var self=this;if(this.activeTab==='all')return this.requests;return this.requests.filter(function(r){return r.status===self.activeTab})}
  },
  mounted(){
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);
var u=sessionStorage.getItem('userId');if(!u){this.$router.push('/login');return}this.fetch()},
  methods:{
    async fetch(){this.loading=true;try{var r=await executeJson({function:"getMyBuyRequests",buyerId:sessionStorage.getItem('userId')},flocker);if(r.data.success)this.requests=r.data.data.buyRequests||[]}catch(e){console.error(e)}this.loading=false},
    countStatus(s){return this.requests.filter(function(r){return r.status===s}).length},
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})}
  }
};
</script>
